<template>
  <sui-select :options="matchOpts" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import { debounce } from 'lodash-es'

export default {
  name: 'SuiCompetitionMatchSelect',
  inject: {
    SuiForm: {
      default: null
    },
    SuiFormPage: {
      default: null
    }
  },
  props: {
    competitionId: {
      type: [Number, String],
      default: undefined
    },
    stageId: {
      type: [Number, String],
      default: undefined
    },
    configGroupMap: {
      type: Object
    },
    catMap: {
      type: Object
    }
  },
  data() {
    return {
      matchOptions: []
    }
  },
  computed: {
    _model() {
      return (this.SuiForm && this.SuiForm.model) || {}
    },
    _competitionId() {
      if (this.competitionId !== undefined) {
        return this.competitionId
      }
      return this._model.competitionId
    },
    _stageId() {
      if (this.stageId !== undefined) {
        return this.stageId
      }
      return this._model.stageId
    },
    matchOpts() {
      return this.matchOptions.map((item) => {
        const groupItem = this.configGroupMap && this.configGroupMap[item.groupId]
        const cateItem = this.catMap && this.catMap[item.catId]
        if (!groupItem || !cateItem) {
          return null
        }
        return {
          value: item.id,
          label: `${groupItem.name} - ${this.catMap[item.catId].label}`
        }
      }).filter(Boolean)
    }
  },
  watch: {
    _competitionId: {
      immediate: true,
      handler(val) {
        this.fetchOptions()
      }
    },
    _stageId: {
      immediate: true,
      handler(val) {
        this.fetchOptions()
      }
    }
  },
  methods: {
    fetchOptions: debounce(async function () {
      await this.$nextTick()

      if (!this._competitionId || !this._stageId) {
        this.matchOptions = []
        return
      }

      let result = await this.$store.dispatch('MerchantSimbart/allActivityCompetitionStageMatch', {
        competitionId: this._competitionId,
        stageId: this._stageId
      })
      if (result) {
        this.matchOptions = result
      }
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/business/competition/SuiCompetitionMatchSelect.vue